import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { BehaviorSubject, Observable, from, of, throwError } from 'rxjs';
import { retry, catchError, take, map, switchMap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
 
const TOKEN_KEY = 'access_token';
 
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public user: Observable<any>;
  private token = new BehaviorSubject(null);
  private server_uri = new BehaviorSubject(null);
  data: Observable<any>;
  
  constructor(private storage: Storage, private http: HttpClient, private plt: Platform, private router: Router, private alertCtrl: AlertController) { 
    this.loadServerUri();
    this.loadStoredToken();  
  }
 
  loadStoredToken() {
    let platformObs = from(this.plt.ready());
 
    this.user = platformObs.pipe(
      switchMap(() => {
        return from(this.storage.get(TOKEN_KEY));
      }),
      map(token => {
        if (token) {
          this.token.next(token);
          return true;
        } else {
          return null;
        }
      })
    );
  }
 
  loadServerUri() {
    this.storage.ready().then(() => {
      this.storage.get('server').then((someval) => {
          this.server_uri = someval;
      });
    });
  }
 
  login(credentials: {host: string, oauth2_client_id: string, oauth2_client_secret: string, email_autocomplete: string, email: string, pw: string }) {

    let postData = new FormData;

   /* let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

   if(!regex.test(credentials.email)) {
    postData.append('username', credentials.email+'@'+credentials.email_autocomplete);
    } else {
   postData.append('username', credentials.email);
  } */

  postData.append('username', credentials.email);
    postData.append('password', credentials.pw);
    postData.append('grant_type', 'password');
    postData.append('client_id', credentials.oauth2_client_id);
    postData.append('client_secret', credentials.oauth2_client_secret);
    postData.append('scope', 'user-profile-read');

    this.storage.set('server_uri', credentials.host);
    this.loadServerUri()

    return this.http.post(credentials.host+'/oauth2/token', postData).pipe(
      take(1),    catchError(this.handleError),
      map(res => {

        var res_obj: any=[];
        res_obj = res;
        return res_obj.access_token;
      }),
      switchMap(token => {
        this.token.next(token);
        let storageObs = from(this.storage.set(TOKEN_KEY, token));
        return storageObs;
      })
    );
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
      alert('Keine Verbindung zum Server.');
    } else {
      alert('Anmeldedaten sind inkorrekt');
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  };

  getToken() {
    return this.token.getValue();
  }

  getFromEndpoint(endpoint: string) {
      return this.http.get(this.server_uri+'/api/v1/'+endpoint, {
      headers: {'Authorization':'Bearer '+this.token.getValue()}
    });
  }

  getServerUri() {
    return this.server_uri+'/api/v1/';
  }

 
  postToEndpoint(endpoint: string, data: object = null) {
    return this.http.post(this.server_uri+'/api/v1/'+endpoint, data, {
    headers: {'Authorization':'Bearer '+this.token.getValue()}
  });
}


  logout() {
    this.storage.remove(TOKEN_KEY).then(() => {
      this.router.navigateByUrl('/login');
      this.token.next(null);
    });
  }
}